import React, { useEffect, useState } from "react";
import { Button, Checkbox, Form, Input, InputNumber, Select } from "antd";
import { useAppDispatch, useAppSelector } from "../hooks/useAppDispatch";
import { fetchKols } from "../store/slices/kolSlice";
import { RootState } from "../store";

interface ExtraInfo {
  brandName?: string;
  time?: string;
  services?: string;
  pax?: number;
  category?: string[];
}

const EmailBatch: React.FC = () => {
  const dispatch = useAppDispatch();
  const { kols } = useAppSelector((state: RootState) => state.kol);

  const [checkedKols, setCheckedKols] = useState<string[]>([]);
  const [kolExtraData, setKolExtraData] = useState<Record<string, ExtraInfo>>({});

  useEffect(() => {
    dispatch(fetchKols());
  }, [dispatch]);

  const handleCheck = (kolId: string, checked: boolean) => {
    setCheckedKols((prev) => (checked ? [...prev, kolId] : prev.filter((id) => id !== kolId)));
  };

  const handleFormChange = (
    kolId: string,
    field: keyof ExtraInfo,
    value: string | number | string[]
  ) => {
    setKolExtraData((prev) => ({
      ...prev,
      [kolId]: {
        ...prev[kolId],
        [field]: value,
      },
    }));
  };

  const handleSendEmails = () => {
    const dataToSend = checkedKols.map((kolId) => ({
      kolId,
      ...kolExtraData[kolId],
    }));
    console.log("Will send the following data:", dataToSend);
    alert("Check console for the data to send!");
  };

  return (
    <div style={{ maxWidth: 800, margin: "0 auto", padding: 32 }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 32,
        }}
      >
        <h2 style={{ margin: 0, fontSize: 28 }}>📧 Email Batch</h2>
        <Button type="primary" size="large" onClick={handleSendEmails}>
          Send Emails
        </Button>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
        {kols.map((kol: any) => {
          const isChecked = checkedKols.includes(kol.id);
          const extraData = kolExtraData[kol.id] || {};

          return (
            <div
              key={kol.id}
              style={{
                border: "1px solid #e0e0e0",
                borderRadius: 12,
                padding: 24,
                boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                backgroundColor: "#fff",
                transition: "box-shadow 0.3s",
              }}
            >
              <Checkbox
                checked={isChecked}
                onChange={(e) => handleCheck(kol.id, e.target.checked)}
                style={{ fontSize: 16 }}
              >
                {kol.name}
              </Checkbox>

              {isChecked && (
                <div style={{ marginTop: 24, marginLeft: 24 }}>
                  <Form layout="vertical">
                    <Form.Item label="Brand Name">
                      <Input
                        value={extraData.brandName || ""}
                        onChange={(e) =>
                          handleFormChange(kol.id, "brandName", e.target.value)
                        }
                        placeholder="e.g. Starbucks"
                      />
                    </Form.Item>

                    <Form.Item label="Time">
                      <Input
                        value={extraData.time || ""}
                        onChange={(e) =>
                          handleFormChange(kol.id, "time", e.target.value)
                        }
                        placeholder="e.g. 2pm, Monday"
                      />
                    </Form.Item>

                    <Form.Item label="Services">
                      <Input
                        value={extraData.services || ""}
                        onChange={(e) =>
                          handleFormChange(kol.id, "services", e.target.value)
                        }
                        placeholder="e.g. Instagram post, Story"
                      />
                    </Form.Item>

                    <Form.Item label="Person/People (Pax)">
                      <InputNumber
                        min={1}
                        value={extraData.pax || 1}
                        onChange={(val) =>
                          handleFormChange(kol.id, "pax", val || 1)
                        }
                        style={{ width: "100%" }}
                      />
                    </Form.Item>

                    <Form.Item label="Category">
                      <Select
                        mode="tags"
                        style={{ width: "100%" }}
                        placeholder="Add one or more categories"
                        value={extraData.category || []}
                        onChange={(value) =>
                          handleFormChange(kol.id, "category", value)
                        }
                      />
                    </Form.Item>
                  </Form>
                </div>
              )}
            </div>
          );
        })}

        {kols.length === 0 && (
          <div style={{ textAlign: "center", color: "#aaa", fontSize: 16 }}>
            No KOLs found
          </div>
        )}
      </div>
    </div>
  );
};

export default EmailBatch;
